import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/OdtuluyuzBiz_logo1000.png';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src={logo} alt="ODTÜlüyüzBiz Logo" className="h-12" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-odtu-gray hover:text-odtu-red font-medium">
              Ana Sayfa
            </Link>
            <Link to="/manifesto" className="text-odtu-gray hover:text-odtu-red font-medium">
              Manifesto
            </Link>
            <Link to="/candidates" className="text-odtu-gray hover:text-odtu-red font-medium">
              Aday Listesi
            </Link>
            <Link to="/candidate-bios" className="text-odtu-gray hover:text-odtu-red font-medium">
              Özgeçmişler
            </Link>
            <Link to="/contact" className="text-odtu-gray hover:text-odtu-red font-medium">
              İletişim
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-odtu-gray hover:text-odtu-red focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-odtu-gray hover:text-odtu-red font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Ana Sayfa
              </Link>
              <Link
                to="/manifesto"
                className="text-odtu-gray hover:text-odtu-red font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Manifesto
              </Link>
              <Link
                to="/candidates"
                className="text-odtu-gray hover:text-odtu-red font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Aday Listesi
              </Link>
              <Link
                to="/candidate-bios"
                className="text-odtu-gray hover:text-odtu-red font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Özgeçmişler
              </Link>
              <Link
                to="/contact"
                className="text-odtu-gray hover:text-odtu-red font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                İletişim
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 